"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using backticks (` `` ` ` `` `).
 * Matches tags of the form ` ``variable`` ` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello ``variable``';
 * const result = replaceTags(text, { variable: 'world' }, Backticks);
 * console.log(result); // Output: 'Hello world'
 */
var Backticks = {
    name: "Backticks",
    openingTag: "``",
    closingTag: "``",
    tagPattern: /``([^`]+)``/g,
    tagStartPattern: /^``/,
    tagEndPattern: /``$/,
};
exports.default = Backticks;
